import { styled, Typography } from '@mui/material';
import Column from 'src/frontend-common/components/Column';

export const LandingWrapper = styled('div')(({ theme }) => ({
  width: '100vw',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#F5F5F5',
  padding: theme.spacing(4),
  '&>div': {
    width: '100%',
    height: '100%',
    maxWidth: 540,
    maxHeight: 875,
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      maxHeight: 615,
    },
    '& img': {
      width: '100%',
      maxWidth: 170,
      marginBottom: theme.spacing(6),
    },
    '&>div': {
      padding: theme.spacing(7, 6),
      alignItems: 'left',
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      borderRadius: 8,
      boxShadow: '0px 15px 35px -8px rgba(0, 0, 0, 0.08)',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
      '&:first-of-type': {
        padding: theme.spacing(3),
        marginBottom: theme.spacing(4),
        backgroundColor: 'transparent',
        boxShadow: 'none',
      },
      '&:last-of-type': {
        padding: theme.spacing(2),
        marginTop: theme.spacing(4),
        backgroundColor: 'transparent',
        boxShadow: 'none',
        border: '1px solid #E0E0E0',
        '&>svg': {
          marginRight: theme.spacing(1),
          fontSize: 15,
        },
        '&>p': {
          textAlign: 'left',
          fontSize: 16,
        },
      },
      '&>h2': {
        fontSize: 24,
        fontWeight: 600,
        lineHeight: '28.8px',
        marginBottom: theme.spacing(4),
      },
      '&>p': {
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '19px',
        color: theme.palette.text.secondary,
        textAlign: 'center',
      },
    },
  },
}));

export const TextWrapper = styled(Column)<{ marg?: 'true' }>(({ theme, marg }) => ({
  marginTop: marg === 'true' ? theme.spacing(0) : theme.spacing(2),
  marginBottom: marg === 'true' ? theme.spacing(4) : theme.spacing(2),
  alignItems: 'center',
  textAlign: 'center',
  padding: 0,
  '&>h2': {
    marginBottom: theme.spacing(2),
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 600,
  },
  '&>p': {
    marginBottom: theme.spacing(0),
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
  },
}));

export const LabelText = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '16.8px',
  letterSpacing: '0.11px',
  marginBottom: 0,
}));
